export default __webpack_public_path__ + "static/media/lora_l.74a42fdf.jpg";